import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  root: {
    paddingBottom: '20px',
  },
  tableStyle: {
    borderSpacing: '0px 10px !important',
    borderCollapse: 'separate !important',
  },
  footerTable: {
    paddingTop: '20px',
    width: '100%',
    '& .spanTotalRows': {
      fontFamily: 'Barlow',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '17px',
      marginRight: '20px',
    },
    '& .selectPage': {
      height: '35px',
    },
    '& .MuiPagination-root': {
      float: 'right',
      '& .MuiPaginationItem-page.Mui-selected': {
        background: '#7D339D',
        borderRadius: '4px',
        color: 'white',
      },
    },
  },
  tableHeadDraggable: {
    background: '#464646',
    color: 'white !important',
    textAlign: 'left',
  },
  tableHeadCell: {
    borderBottom: '2px solid black',
  },
  tableHeadBase: {
    borderBottom: 'groove !important',
  },
  firstTableCellStyle: {
    width: 60,
  },
  lastTableCellStyle: {
    width: 60,
  },
  draggableIcon: {
    marginRight: 12,
  },
  deleteIcon: {
    height: '10.5px !important',
    width: '10.5px !important',
    strokeWidth: '3.2px !important',
  },
  rowStyle: {
    cursor: 'pointer',
    '&:hover': {
      background: '#e9e9e9',
    },
    border: '2px solid black',
  },
  cellStyle: {
    borderBottom: '2px solid rgba(224, 224, 224, 1) !important',
    borderTop: '2px solid rgba(224, 224, 224, 1) !important',
  },
  firstCellStyle: {
    borderBottom: '2px solid rgba(224, 224, 224, 1) !important',
    borderTop: '2px solid rgba(224, 224, 224, 1) !important',
    borderLeft: '2px solid rgba(224, 224, 224, 1) !important',
    borderBottomLeftRadius: '5px !important',
    borderTopLeftRadius: '5px !important',
  },
  lastCellStyle: {
    borderBottom: '2px solid rgba(224, 224, 224, 1) !important',
    borderTop: '2px solid rgba(224, 224, 224, 1) !important',
    borderRight: '2px solid rgba(224, 224, 224, 1) !important',
    borderBottomRightRadius: '5px !important',
    borderTopRightRadius: '5px !important',
  },

})

export default styleOverride
